export default __webpack_public_path__ + "static/032-70846ee6fcad0ff499ea847d04eeb3bb.png";